export function matchesTerm (base: string, term: string, options?: { isExact: boolean; }): boolean {
  if (options?.isExact)
    return base === term;

  return base.toLowerCase().trim()
    .includes(term.toLowerCase().trim());
}
